export const novemberUppercase = "ara";
export default {novemberUppercase};